import type { CSSProperties, ReactNode } from "react";
import { Container } from "react-bootstrap";

export const ATTENDANCE_PAGE_HEIGHT = "calc(100vh - 90px)";


interface AttendancePageShellProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export function AttendancePageShell({
  children,
  className = "",
  style,
}: AttendancePageShellProps) {
  return (
    <Container
      fluid
      className={`p-0 mt-2 me-2 pe-2`.trim()}
      style={{ ...style }}
    >
      <div className="bg-white m-0 p-2 rounded-3" style={{ height: ATTENDANCE_PAGE_HEIGHT, overflowY: "auto" }}>
        {children}
      </div>
    </Container>
  );
}
